import Vue from 'vue';
import Router from 'vue-router';
import Badges from '@home/pages/Badges';
import Badge from '@home/pages/Badge';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      component: Badges,
    },
    {
      path: '/badge/:badgeId',
      component: Badge,
      props: true,
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
});
